import React from 'react'
// import Hotel from "../../assets/img/bg/an-img-01.png"
import Booking from "../../assets/img/bg/booking-img.png"


function Book() {
  return (
    <>
        <section className="booking pt-120 pb-120 p-relative fix">
                {/* <div className="animations-01"><img src={Hotel} alt="an-img-01"/></div> */}
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                             <div className="contact-bg02">
                                <div className="section-title center-align">
                                    <h5>Reserva tu cuarto en línea</h5>
                                    <h2>
                                      Hotel La Finca
                                    </h2>
                                </div>                                
                                <form action="mail.php" method="post" className="contact-form mt-30">
                                    <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="contact-field p-relative c-name mb-20">                                    
                                           <label><i className="fal fa-badge-check"></i> Check In</label>
                                            <input type="date" id="chackin2" name="date" />
                                        </div>                               
                                    </div>

                                    <div className="col-lg-6 col-md-6">                               
                                        <div className="contact-field p-relative c-subject mb-20">                                   
                                           <label><i className="fal fa-times-octagon"></i> Check Out</label>
                                            <input type="date" id="chackout2" name="date" />
                                        </div>
                                    </div>		
                                    <div className="col-lg-6 col-md-6">                               
                                        <div className="contact-field p-relative c-subject mb-20">                                   
                                            <label><i className="fal fa-users"></i> Adultos</label>
                                            <select name="adults" id="adu2">
                                                <option value="sports-massage">Adultos</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                            </select>
                                        </div>
                                    </div>	
                                    <div className="col-lg-6 col-md-6">                               
                                        <div className="contact-field p-relative c-subject mb-20">                                   
                                            <label><i className="fal fa-users"></i> Niños</label>
                                            <select name="adults" id="adu2">
                                                <option value="sports-massage">Niños</option>
                                                <option value="5">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                            </select>
                                        </div>
                                    </div>	
                                    <div className="col-lg-6 col-md-6">                               
                                        <div className="contact-field p-relative c-option mb-20">                                   
                                            <label><i className="fal fa-concierge-bell"></i> Habitación</label>
                                            <select name="room" id="rm2">
                                                <option value="sports-massage">Habitación</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">                               
                                        <div className="contact-field p-relative c-option mb-20">                                   
                                            <label><i className="fal fa-concierge-bell"></i>Tipo de Habitación</label>
                                            <select name="room" id="rm2">
                                                <option value="sports-massage">Tipo de Habitación</option>
                                                <option value="1">Habitación con Cama King</option>
                                                <option value="2">Habitación con Camas Dobles</option>
                                                <option value="3">Suite</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="slider-btn mt-15">                                          
                                            <button className="btn ss-btn" data-animation="fadeInRight" data-delay=".8s"><span>Reservar</span></button>				
                                        </div>                             
                                    </div>
                                </div>
                            </form>                            
                            </div>  
                                             
                        </div>
                        <div className="col-lg-6 col-md-6">
                             <div className="booking-img">
                                 <img src={Booking} alt="img"/>
                            </div>
                        </div>
                    </div>
                </div>
        </section>
    </>
  )
}

export default Book